interface Props {
  value: string;
  onChange: (v: string) => void;
  name?: string;
  autoFocus?: boolean;
  disabled?: boolean;
}

/** +976 угтвартай 8 оронтой утасны дугаарын талбар (нэвтрэх хуудас). */
export function PhoneField({ value, onChange, name = 'phone', autoFocus, disabled }: Props) {
  return (
    <div>
      <label className="ts-form-label" htmlFor={name}>
        Утасны дугаар <span className="text-red-500">*</span>
      </label>
      <div className="auth-phone-wrap">
        <span className="auth-phone-prefix">+976</span>
        <input
          id={name}
          name={name}
          className="ts-input"
          inputMode="numeric"
          autoComplete="tel-national"
          maxLength={8}
          placeholder="99112233"
          value={value}
          onChange={(e) => onChange(e.currentTarget.value.replace(/\D/g, ''))}
          required
          autoFocus={autoFocus}
          disabled={disabled}
        />
      </div>
    </div>
  );
}
